import React from "react";

export default function CameraBasedHandTrackingIcon(props: any) {
  return (
    <svg
      {...props}
      width="80"
      height="80"
      viewBox="0 0 80 80"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(13 11)">
          <path
            d="M29.483 9.472v10.695a.612.612 0 0 1-1.226 0V4.583a2.754 2.754 0 0 0-2.758-2.75 2.754 2.754 0 0 0-2.758 2.75v14.361a.612.612 0 0 1-1.226 0V2.75A2.754 2.754 0 0 0 18.756 0a2.754 2.754 0 0 0-2.758 2.75v16.194a.612.612 0 0 1-1.226 0V6.417a2.754 2.754 0 0 0-2.758-2.75 2.754 2.754 0 0 0-2.759 2.75v20.991l-3.92-5.58a2.938 2.938 0 0 0-3.957-.802 2.918 2.918 0 0 0-.896 4.085l8.204 12.447A14.345 14.345 0 0 0 20.666 44C28.582 44 35 37.602 35 29.71V9.471a2.754 2.754 0 0 0-2.758-2.75 2.754 2.754 0 0 0-2.759 2.75"
            stroke="#000"
            strokeWidth=".5"
            strokeLinejoin="round"
          />
          <circle fill="#000" cx="3.25" cy="24" r="1.5" />
          <circle fill="#000" cx="20.5" cy="39.5" r="1.5" />
          <circle fill="#000" cx="11.5" cy="33.5" r="1.5" />
          <g transform="translate(10.5 6)">
            <circle fill="#000" cx="1.5" cy="1.5" r="1.5" />
            <circle fill="#000" cx="1.5" cy="10.5" r="1.5" />
            <circle fill="#000" cx="1.5" cy="19.5" r="1.5" />
            <path stroke="#000" strokeWidth=".5" d="M1.5 1.5v18l8.5 14" />
          </g>
          <g transform="translate(17.25 2)">
            <circle fill="#000" cx="1.5" cy="1.5" r="1.5" />
            <circle fill="#000" cx="1.5" cy="10.5" r="1.5" />
            <circle fill="#000" cx="1.5" cy="19.5" r="1.5" />
            <path stroke="#000" strokeWidth=".5" d="M1.5 1.5v18l1.75 18" />
          </g>
          <g transform="translate(20.5 4)">
            <circle fill="#000" cx="5" cy="1.5" r="1.5" />
            <circle fill="#000" cx="5" cy="10.5" r="1.5" />
            <circle fill="#000" cx="5" cy="19.5" r="1.5" />
            <path stroke="#000" strokeWidth=".5" d="M5 1.5v18l-5 16" />
          </g>
          <g transform="translate(30.75 9)" fill="#000">
            <circle cx="1.5" cy="1.5" r="1.5" />
            <circle cx="1.5" cy="10.5" r="1.5" />
            <circle cx="1.5" cy="19.5" r="1.5" />
          </g>
          <path
            stroke="#000"
            strokeWidth=".5"
            d="m3.25 24 8.25 9.5 9 6 11.75-11v-18"
          />
        </g>
        <path
          d="M57.067 48h-3.134a.981.981 0 0 0-.974.86l-.867 6.99h6.816l-.867-6.99a.981.981 0 0 0-.974-.86zm-9.843 9.32c-2.882 0-5.292 2.13-5.76 4.906a5.928 5.928 0 0 0-.082.982v4.905c0 .334.029.662.082.981.468 2.777 2.878 4.906 5.76 4.906h16.552c2.882 0 5.292-2.13 5.76-4.906.053-.319.082-.647.082-.98v-4.906c0-.334-.029-.663-.082-.982-.468-2.776-2.878-4.905-5.76-4.905H47.224zm23.787 4.906c.044.32.068.648.068.982v4.905c0 .334-.024.662-.068.981h2.008c.542 0 .981-.439.981-.98v-4.906a.981.981 0 0 0-.981-.982H71.01zm-31.09 5.887c0 .334.024.662.068.981h-2.008a.981.981 0 0 1-.981-.98v-4.906c0-.542.44-.982.981-.982h2.008a7.216 7.216 0 0 0-.068.982v4.905z"
          fill="#000"
        />
        <g fill="#000">
          <path d="M6 6h2v12H6z" />
          <path d="M6 6h12v2H6z" />
        </g>
        <g fill="#000">
          <path d="M60 6h-2v12h2z" />
          <path d="M60 6H48v2h12z" />
        </g>
        <g fill="#000">
          <path d="M6 61h2V49H6z" />
          <path d="M6 61h12v-2H6z" />
        </g>
      </g>
    </svg>
  );
}
